
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase'
import header1 from '@/components/headers/front-end-header.vue';
import footer1 from '@/components/footers/footer.vue';
import QrCode from 'qrcodejs2';
import RechargeCardOrder from '@/store/entities/ordering/RechargeCardOrder';
import RechargeCard from '@/store/entities/finance/RechargeCard';
import AppConst from '@/lib/appConst';
import Subject from '@/store/entities/portal/Subject';

@Component({
  components:{header1,footer1}
})
export default class CoinCharging extends AbpBase {
  subject: Subject = new Subject();

  created(){
    this.$store.commit('app/hideSidebarMenu');
    this.getSubject();
  }

  getSubject(){
    this.$store.dispatch({
      type:'subject/getByName',
      data: this.$route.name
    }).then(data => {
      this.subject = data;
    });
  }

}
